export const CONSIGNMENT_KEY = 'consignment'

export const consignmentQueryKeys = {
  all: [CONSIGNMENT_KEY] as const,
  details: () => [...consignmentQueryKeys.all, 'detail'] as const,
  detailsByParams: (params: { transitOperationId: number | null }) => [...consignmentQueryKeys.details(), params] as const,
  summaries: () => [...consignmentQueryKeys.all, 'summary'] as const,
  summary: (id: number | null) => [...consignmentQueryKeys.summaries(), id] as const,
}
